import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Caption1, Body1, Body2, ListSeparator } from "@activecollab/components";
import { getCurrentBillingPeriod, getCurrentUsersCount } from "~/store/selectors/selector.accountSettings";
import { getPriceBreakdown } from "~/store/selectors/selector.subscriptionBrakeDownPrice";

const PriceTooltipContent = () => {
  const { t } = useTranslation();
  const countMembers = useSelector((state) => getCurrentUsersCount(state));
  const priceBreakDown = useSelector(getPriceBreakdown);
  const billingPeriod = useSelector(getCurrentBillingPeriod);
  const renderPerSeatAddons = priceBreakDown?.per_seat_addons.map((perSeatAddOn, index) => {
    return (
      <div
        key={index}
        className="tw-grid tw-grid-cols-[120px_auto]"
      >
        <Body2 color="secondary">{perSeatAddOn.verbose_name} Bundle:</Body2>
        <Body2
          color="secondary"
          weight="bold"
          className="tw-justify-self-end"
          data-testid="Per Seat Add On"
        >
          ${perSeatAddOn.price}
        </Body2>
      </div>
    );
  });

  const renderNonPerSeatAddons = priceBreakDown?.non_per_seat_addons.map((nonPerSeatAddOn, index) => {
    return (
      <div
        key={index}
        className="tw-grid tw-grid-cols-[120px_auto]"
      >
        <Body2 color="secondary">{nonPerSeatAddOn.verbose_name} Bundle:</Body2>
        <Body2
          color="secondary"
          weight="bold"
          className="tw-justify-self-end"
          data-testid="Non Per Seat Add On"
        >
          ${nonPerSeatAddOn.price}
        </Body2>
      </div>
    );
  });
  const hasAddons = useMemo(() => {
    return priceBreakDown?.per_seat_addons.length > 0 || priceBreakDown?.non_per_seat_addons.length > 0;
  }, [priceBreakDown?.non_per_seat_addons.length, priceBreakDown?.per_seat_addons.length]);

  return (
    <>
      <div className="tw-grid tw-grid-cols-[120px_auto]">
        <Body2
          color="secondary"
          className="tw-mb-3"
        >
          {t("Members")}:
        </Body2>
        <Body2
          color="secondary"
          weight="bold"
          className="tw-justify-self-end"
          data-testid="Members"
        >
          {countMembers}
        </Body2>
        <Body2 color="secondary">{t("ActiveCollab app")}:</Body2>
        <Body2
          color="secondary"
          weight="bold"
          className="tw-justify-self-end"
          data-testid="Plan Price"
        >
          ${priceBreakDown?.plan_price}
        </Body2>
      </div>
      {hasAddons ? (
        <>
          <ListSeparator className="tw-mx-0 tw-my-3" />
          {priceBreakDown?.per_seat_addons.length !== 0 ? renderPerSeatAddons : null}
          {priceBreakDown?.non_per_seat_addons.length !== 0 ? renderNonPerSeatAddons : null}
        </>
      ) : null}
      <ListSeparator className="tw-mx-[-16px] tw-mt-3 tw-mb-2" />
      <div className="tw-grid tw-grid-cols-[120px_auto]">
        <Body1
          color="secondary"
          weight="bold"
        >
          {t("Total")}:
        </Body1>
        <Body1
          color="secondary"
          weight="bold"
          className="tw-justify-self-end"
          data-testid="Total"
        >
          ${priceBreakDown?.total}
        </Body1>
      </div>
      <ListSeparator className="tw-mx-[-16px] tw-mt-2 tw-mb-3" />
      <Caption1
        color="secondary"
        data-testid="Explainer"
      >
        + applicable taxes / {billingPeriod}
      </Caption1>
    </>
  );
};

export default PriceTooltipContent;
